<template>
	<router-view />
</template>
<script>
export default {
	name: 'UnauthenticatedContext',
};
</script>
